"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactCountup = _interopRequireDefault(require("react-countup"));
var _components = require("../../../components");
var _Forms = require("../../../components/Forms");
var _helpers = require("../../../helpers");
var _reactstrap = require("reactstrap");
var _moment = _interopRequireDefault(require("moment"));
var _uuid = _interopRequireDefault(require("uuid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Counter = ({
  dataset
}) => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactCountup.default, _extends({}, dataset, {
    delay: 0,
    start: 0,
    end: parseFloat(dataset.numberToCountTo),
    duration: 1,
    decimals: dataset.numberOfDecimalPlaces || 0,
    decimal: dataset.decimalCharacter || ".",
    suffix: dataset.numberToCountToUnit && ` ${dataset.numberToCountToUnit}` || ``
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "analytics-muted"
  }, dataset.displayedEndString));
};
class NumberWithDate extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onStartDateChange", e => {
      {
        e.preventDefault && e.preventDefault();
      }
      if (e <= this.state.endDate) {
        let date = (0, _moment.default)(e);
        let startDate = date.toISOString();
        let startDateDisplay = date.format("DD.MM.YYYY");
        this.setState({
          startDate: startDate,
          startDateDisplay: startDateDisplay,
          startCalendarOpen: false
        });
        let params = {
          startDate: startDate,
          endDate: this.state.endDate
        };
        this.props.getResult(this.props.dataset.id, params);
      }
    });
    _defineProperty(this, "onEndDateChange", e => {
      {
        e.preventDefault && e.preventDefault();
      }
      if (e >= this.state.startDate) {
        let date = (0, _helpers.getEndOfDay)(e);
        let endDate = date.toISOString();
        let endDateDisplay = date.format("DD.MM.YYYY");
        this.setState({
          endDate: endDate,
          endDateDisplay: endDateDisplay,
          endCalendarOpen: false
        });
        let params = {
          startDate: this.state.startDate,
          endDate: endDate
        };
        this.props.getResult(this.props.dataset.id, params);
      }
    });
    _defineProperty(this, "toggleStartCalendar", () => {
      this.setState({
        startCalendarOpen: this.state.startCalendarOpen ? false : true,
        endCalendarOpen: false
      });
    });
    _defineProperty(this, "toggleEndCalendar", () => {
      this.setState({
        endCalendarOpen: this.state.endCalendarOpen ? false : true,
        startCalendarOpen: false
      });
    });
    _defineProperty(this, "handleShortcut", shortcut => {
      let dateObject = (0, _helpers.getTimeSpan)(shortcut.function);
      this.setState({
        startDate: dateObject.startDate,
        startDateDisplay: (0, _moment.default)(dateObject.startDate).format("DD.MM.YYYY"),
        startCalendarOpen: false,
        endDate: dateObject.endDate,
        endDateDisplay: (0, _moment.default)(dateObject.endDate).format("DD.MM.YYYY"),
        endCalendarOpen: false
      });
      let params = {
        startDate: dateObject.startDate,
        endDate: dateObject.endDate
      };
      this.props.getResult(this.props.dataset.id, params);
    });
    let _dateObject;
    if (props.dataset.shortcuts) {
      _dateObject = (0, _helpers.getTimeSpan)(props.dataset.shortcuts[0].function);
    } else {
      _dateObject = (0, _helpers.getTimeSpan)("TODAY");
    }
    this.state = {
      startDate: _dateObject.startDate,
      startDateDisplay: (0, _moment.default)(_dateObject.startDate).format("DD.MM.YYYY"),
      startCalendarOpen: false,
      endDate: _dateObject.endDate,
      endDateDisplay: (0, _moment.default)(_dateObject.endDate).format("DD.MM.YYYY"),
      endCalendarOpen: false
    };
  }
  componentDidMount() {
    document.addEventListener("click", () => {
      if (
      // eslint-disable-next-line no-restricted-globals
      !event.target.closest(".calendarWidget") &&
      // eslint-disable-next-line no-restricted-globals
      !event.target.closest(".widgetLink")) {
        this.setState({
          startCalendarOpen: false,
          endCalendarOpen: false
        });
      }
    }, false);
    let params = {
      startDate: this.state.startDate,
      endDate: this.state.endDate
    };
    this.props.getResult(this.props.dataset.id, params);
  }
  render() {
    const {
      dataset
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card rounded shadow mb-3 p-5",
      style: {
        height: "25rem"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "card-title mb-4"
    }, dataset.title), /*#__PURE__*/_react.default.createElement("p", {
      className: "text-muted mb-5"
    }, dataset.description), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-text mt-5"
    }, !dataset.fetched && /*#__PURE__*/_react.default.createElement(_components.Spinner, null), dataset.fetched && !dataset.error && dataset.data && /*#__PURE__*/_react.default.createElement("div", {
      className: "container-fluid"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row align-items-start"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-4 pl-0"
    }, /*#__PURE__*/_react.default.createElement("h1", null, /*#__PURE__*/_react.default.createElement(Counter, {
      dataset: dataset.data
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-4"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("small", {
      className: "text-muted text-uppercase"
    }, "Start date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "widgetLink",
      onClick: this.toggleStartCalendar
    }, /*#__PURE__*/_react.default.createElement("h5", null, this.state.startDateDisplay)), this.state.startCalendarOpen && /*#__PURE__*/_react.default.createElement(_reactstrap.FormGroup, {
      className: "shadow calendarWidget",
      style: {
        zIndex: "999"
      }
    }, /*#__PURE__*/_react.default.createElement(_Forms.Date, {
      value: this.state.startDate,
      onChange: e => this.onStartDateChange(e),
      maxDate: this.state.endDate
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-4"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("small", {
      className: "text-muted text-uppercase"
    }, "End date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "widgetLink",
      onClick: this.toggleEndCalendar
    }, /*#__PURE__*/_react.default.createElement("h5", null, this.state.endDateDisplay)), this.state.endCalendarOpen && /*#__PURE__*/_react.default.createElement(_reactstrap.FormGroup, {
      className: "shadow calendarWidget",
      style: {
        zIndex: "999"
      }
    }, /*#__PURE__*/_react.default.createElement(_Forms.Date, {
      value: this.state.endDate,
      onChange: e => this.onEndDateChange(e),
      minDate: this.state.startDate
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row mt-5 mb-0",
      style: {
        zIndex: "2",
        position: "absolute",
        bottom: "4rem"
      }
    }, dataset.shortcuts && dataset.shortcuts.map(shortcut => /*#__PURE__*/_react.default.createElement("button", {
      key: _uuid.default.v4(),
      type: "submit",
      onClick: () => this.handleShortcut(shortcut),
      className: "btn btn-secondary mr-5"
    }, shortcut.name)))), dataset.error && /*#__PURE__*/_react.default.createElement("div", {
      className: "alert alert-danger"
    }, dataset.error.Message))));
  }
}
var _default = exports.default = NumberWithDate;
module.exports = exports.default;